<template>
    <div ref="popup" class="popup" @mousedown.self="mouseDown" @mouseup.self="mouseUp">
        <div ref="popupDialog"
             class="popup-dialog"
             :class="{above: positionAbove}"
             :style="{top: position.y + 'px', left: position.x + 'px'}"
        >
            <header>
                <slot name="title"></slot>
                <button class="close" @click="close">✕</button>
            </header>

            <div class="popup-body">
                <slot></slot>
            </div>

            <footer v-if="$slots.footer">
                <slot name="footer"></slot>
            </footer>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: "Popup",

        data() {
            return {
                positionAbove: false,
                canClose: false,
            }
        },

        computed: {
            ...mapState('editPopup', [
                'currentPopup',
            ]),

            position() {
                return this.currentPopup.position;
            },

        },

        methods: {
            ...mapActions('editPopup', [
                'clearCurrentPopup',
            ]),

            close() {
                this.clearCurrentPopup();
            },

            mouseDown() {
                this.canClose = true;
            },

            mouseUp() {
                if (this.canClose) {
                    this.close();
                }
            },

            escKey(e) {
                const keyCode = e.code;

                if(keyCode === 'Escape') {
                    this.close();
                }
            },

            setPopupPosition() {
                // if the popup is too low on the canvas, it can end up below the screen,
                // so we placed it below the pointer
                let popupHeight = this.$refs['popup'].offsetHeight;
                let popupHeightDialog = this.$refs['popupDialog'].offsetHeight;
                let offset = 40; // include offset from the css

                let popupBottomPosition = this.position.y + popupHeightDialog + offset;

                if (popupBottomPosition > popupHeight) {
                    this.positionAbove = true;
                }
            },

        },

        beforeMount() {
            window.addEventListener("keydown", this.escKey, false);
        },

        beforeUnmount() {
            window.removeEventListener("keydown", this.escKey);
        },

        mounted() {
            this.setPopupPosition();
        },

    }
</script>

<style scoped>
    .popup {
        position: absolute;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .popup-dialog {
        position: absolute;
        z-index: 1;
        min-width: 200px;
        border: 1px solid;
        font-size: 14px;
        background: #fff;
        box-shadow: 2px 2px 2px #555;
        transform: translate(-50%, 30px);
    }

    .above {
        transform: translate(-50%, calc(-100% - 20px));
    }

    header {
        display: flex;
        justify-content: space-between;
        padding: 5px 8px;
        border-bottom: 1px solid #999;
        font-weight: 700;
    }

    .popup-body {
        padding: 16px 8px;
    }

    footer {
        display: flex;
        justify-content: center;
        padding: 8px;
        border-top: 1px solid #999;
        background: #ddd;
    }

    .close {
        flex: 0 1 auto;
        margin: 0 -2px 0 10px;
        background: none;
        box-shadow: none;
        border: none;
        padding: 0;
        width: 15px;
        cursor: pointer;
    }
</style>

<style>
    footer button {
        margin: 0 10px;
    }
</style>